import { EKycVerificationStatus } from '@exam-center/graphql';
import { z } from 'zod';

export const ProctoringEkycVerificationFormSchema = z
  .object({
    photoClarity: z.enum(['CORRECT', 'INCORRECT'], {
      required_error: 'กรุณาเลือกตัวเลือกใดตัวเลือกหนึ่ง',
    }),
    photoIdentityMatch: z.enum(['CORRECT', 'INCORRECT'], {
      required_error: 'กรุณาเลือกตัวเลือกใดตัวเลือกหนึ่ง',
    }),
    idPhotoClarity: z.enum(['CORRECT', 'INCORRECT'], {
      required_error: 'กรุณาเลือกตัวเลือกใดตัวเลือกหนึ่ง',
    }),
    verificationStatus: z.enum(Object.values(EKycVerificationStatus) as [string, ...string[]]),
    comment: z.string(),
  })
  .refine(
    (data) =>
      !(data.verificationStatus === EKycVerificationStatus.Rejected && data.comment.length === 0),
    {
      message: 'กรุณากรอกสาเหตุ',
      path: ['comment'],
    },
  );

export type ProctoringEkycVerificationFormType = z.infer<
  typeof ProctoringEkycVerificationFormSchema
>;
